var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-profile-field"},[_c('b-form-tags',{staticClass:"mb-2",attrs:{"size":"md","tag-variant":"dark","placeholder":"Add new..."},on:{"input":function($event){return _vm.updateValue($event)}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }